export const copyLinkDataSet = { cy: 'copy-link-button' };
